import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";
import useQuery from "../../helpers/useQuery";
import Loading from "../../components/Loading";
import { actions } from '../../store/reducers/authentication';
import { useNavigate } from "react-router-dom";

export default function AppRedirect() {
  const q = useQuery();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const mod = q.get('module');
    const token = q.get('token');
    const path = q.get('path');
    const prev = q.get('prev');

    StorageManager.set('token', token);

    if (prev) {
      StorageManager.set('previous', prev);
    }

    dispatch(actions.check(
      '/redirect',
      () => {
        if (path) {
          navigate(path);
          return;
        }

        navigate(`/app/${mod}`);
      },
      mod
    ));
  }, []);

  return <Loading />;
}
